import { LogLevel, log } from "src/logger";

export enum MetricAction {
  APP_INIT = "APP_INIT",
  CHANGE_LOCALE = "CHANGE_LOCALE",
  COMPLIANCE_HELPER_PANEL_ACCORDION_ITEM = "COMPLIANCE_HELPER_PANEL_ACCORDION_ITEM",
  COMPLIANCE_HELPER_PANEL_CLOSING = "COMPLIANCE_HELPER_PANEL_CLOSING",
  COMPLIANCE_HELPER_PANEL_OPENING = "COMPLIANCE_HELPER_PANEL_OPENING",
  COMPLIANCE_HELPER_PANEL_TOGGLE_CHANGE_ON = "COMPLIANCE_HELPER_PANEL_TOGGLE_CHANGE_ON",
  COMPLIANCE_HELPER_PANEL_TOGGLE_CHANGE_OFF = "COMPLIANCE_HELPER_PANEL_TOGGLE_CHANGE_OFF",
  COMPLIANCE_HELPER_PANEL_USER_ACTION = "COMPLIANCE_HELPER_PANEL_USER_ACTION",
  DOCUMENT_HISTORY_TAB_CLICK = "DOCUMENT_HISTORY_TAB_CLICK",
  DOCUMENT_HISTORY_TAB_PAGINATION = "DOCUMENT_HISTORY_TAB_PAGINATION",
  DOCUMENT_HISTORY_TAB_SEARCHES = "DOCUMENT_HISTORY_TAB_SEARCHES",
  DOCUMENT_ITEMS_TAB_CLICK = "DOCUMENT_ITEMS_TAB_CLICK",
  DOCUMENT_ITEMS_TAB_DETAILS_CLICK = "DOCUMENT_ITEMS_TAB_DETAILS_CLICK",
  DOCUMENT_ITEMS_TAB_EXPAND_ERRORED_LINE_ITEMS_CLICK = "DOCUMENT_ITEMS_TAB_EXPAND_ERRORED_LINE_ITEMS_CLICK",
  DOCUMENT_ITEMS_TAB_FILTER_RULE_SEVERITY_LINE_ITEMS_CLICK = "DOCUMENT_ITEMS_TAB_FILTER_RULE_SEVERITY_LINE_ITEMS_CLICK",
  DOCUMENT_ITEMS_TAB_SEARCHES = "DOCUMENT_ITEMS_TAB_SEARCHES",
  FORCE_REJECTION_CANCEL = "FORCE_REJECTION_CANCEL",
  FORCE_REJECTION_CONFIRM = "FORCE_REJECTION_CONFIRM",
  INBOUND_COMPLIANCE_FILTER_WITH_DISCREPANCIES = "INBOUND_COMPLIANCE_FILTER_WITH_DISCREPANCIES",
  INBOUND_COMPLIANCE_TAB_CLICK = "INBOUND_COMPLIANCE_TAB_CLICK",
  MISMATCH_TAB_FILTER_RULE_SEVERITY_CLICK = "MISMATCH_TAB_FILTER_RULE_SEVERITY_CLICK",
  REQUEST_HISTORY_PAYLOAD_SIZE = "REQUEST_HISTORY_PAYLOAD_SIZE",
  REQUEST_LINE_ITEMS_PAYLOAD_SIZE = "REQUEST_LINE_ITEMS_PAYLOAD_SIZE",
  VALIDATION_TAB_USER_ACTION = "VALIDATION_TAB_USER_ACTION",
}

interface MetricActionData {
  value?: string;
  errored?: boolean;
}

const publishMetric = (
  action: MetricAction,
  { value, errored }: MetricActionData = {}
): void => {
  const attributes = value ? { attributes: { value } } : {};
  log({
    level: LogLevel.INFO,
    operationNamespace: "metric",
    action: errored ? `${action.toString()}_ERROR` : action.toString(),
    message: `Publishing metric ${action}`,
    ...attributes,
  });
};

export default publishMetric;
